export const fetchMatchupPreview = async (gamePk) => {
  const [gameRes, awayProbRes, homeProbRes] = await Promise.all([
    fetch(`https://statsapi.mlb.com/api/v1/game/${gamePk}/feed/live`),
    fetch(`https://statsapi.mlb.com/api/v1/game/${gamePk}/feed/live`),
  ]);
  const feed = gameRes.ok ? await gameRes.json() : null;
  const gameData = feed?.gameData || null;
  const awayId = gameData?.teams?.away?.id;
  const homeId = gameData?.teams?.home?.id;

  const [awayStatsRes, homeStatsRes, awayRosterRes, homeRosterRes] = await Promise.all([
    fetch(`https://statsapi.mlb.com/api/v1/teams/${awayId}/stats?stats=season&group=hitting,pitching&season=${new Date().getFullYear()}`),
    fetch(`https://statsapi.mlb.com/api/v1/teams/${homeId}/stats?stats=season&group=hitting,pitching&season=${new Date().getFullYear()}`),
    fetch(`https://statsapi.mlb.com/api/v1/teams/${awayId}/roster?rosterType=active`),
    fetch(`https://statsapi.mlb.com/api/v1/teams/${homeId}/roster?rosterType=active`),
  ]);

  const awayStats = awayStatsRes.ok ? await awayStatsRes.json() : null;
  const homeStats = homeStatsRes.ok ? await homeStatsRes.json() : null;
  const awayRoster = awayRosterRes.ok ? await awayRosterRes.json() : null;
  const homeRoster = homeRosterRes.ok ? await homeRosterRes.json() : null;

  return { feed, gameData, awayStats, homeStats, awayRoster, homeRoster };
};